module.exports = __webpack_public_path__ + "static/room1-2-9ab6d765d839db1d0d67b75438b5b0d4.jpg";